import { FC } from "react";
import { IBackDropModalSettings } from "types/other/TypeOthers";

const OverlayModalCommon: FC<IBackDropModalSettings> = ({
  open,
  onClose,
  children,
  lowerZindex,
}) => {
  const closeModal = (e: any) => {
    if (e.target.id === "overlay") {
      onClose();
    }
  };
  if (!open) return null;

  return (
    <div
      style={{ zIndex: lowerZindex ? 9990 : 9999 }}
      onClick={(e) => {
        closeModal(e);
      }}
      id={"overlay"}
      className="customModalBackdrop"
    >
      {children}
    </div>
  );
};
export default OverlayModalCommon;
